export default __webpack_public_path__ + "static/media/Shapes_24.b0e71659.png";